

define(['squid/index', './directive', './xo-bml-apply/route', './xo-bml-terms-and-conditions/route', './xo-bml-signature/route'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-bml-display.route', ['squid', 'xo-bml-display.directive', 'xo-bml-apply.route', 'xo-bml-terms-and-conditions.route', 'xo-bml-signature.route']).factory('$BMLDisplay', function ($ComponentRoute) {

        return $ComponentRoute.extend('BmlDisplay', {

            name: 'bmldisplay',
            directive: 'xo-bml-display',
            trackingData: {
                fptiState: 'ppc_display'
            },
            titleContent: 'applyForBml.bmlApplyHeadline',
            children: [{
                name: '$BmlApplyRoute'
            }, {
                name: '$BmlTermsAndConditionsRoute'
            }, {
                name: '$BmlSignatureRoute'
            }]
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-credit-components/src/bml-display/route.js
 ** module id = 460
 ** module chunks = 1
 **/